// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2UsIV","left":"StickyBox_left__3F_uH","right":"StickyBox_right__2xr-m"};